import "./BusinessOverview.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import GuestTestimonials from "./sections/GuestTestimonials";
import HowWeHelp from "./sections/HowWeHelp";
import QualityAssuranceTimeline from "./sections/QualityAssuranceTimeline";
import FinancialBenefits from "./sections/FinancialBenefits";
import EsgImpact from "./sections/EsgImpact";
import FutureProofYourWorkflow from "./sections/FutureProofYourWorkflow";
import Footer from "@/reusable_sections/Footer";
export default function BusinessOverviewPage() {
  return <div>
      <Header />
      <Hero />
      <GuestTestimonials />
      <HowWeHelp />
      <QualityAssuranceTimeline />
      <FinancialBenefits />
      <EsgImpact />
      <FutureProofYourWorkflow />
      <Footer />
    </div>;
}